import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { store, history } from 'store';

import Steps from 'components/steps';


if (localStorage.language) {
  store.dispatch({ type: 'LANGUAGE', language: localStorage.language });
}

const App = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Steps />
    </ConnectedRouter>
  </Provider>
);

export default App;
